import * as React from 'react';
import type { OwnerOrCompanyRow } from '../../helpers/opportunityReportingChartTypes';
import { OwnerOrCompanyBarChart } from '../OwnerOrCompanyBarChart';

interface DealSizeByOwnerChartProps {
	data: OwnerOrCompanyRow[];
	isLoading?: boolean;
	className?: string;
}

export const DealSizeByOwnerChart: React.FC<DealSizeByOwnerChartProps> = props => (
	<OwnerOrCompanyBarChart
		{...props}
		title='Deal size by owner'
		emptyMessage='No opportunity data in the current load (owners appear when the API includes assignees)'
	/>
);
